import { getToken } from "../../helpers/get-token";
import axiosInstance from "../../axios/instance";

async function deleteUser(id) {
    try {
        const token = getToken();
        axiosInstance.defaults.headers.common['authorization'] = token;
        const response = await axiosInstance.delete(process.env.REACT_APP_HUB_URL + '/api/users/' + id)
        return response?.data;
    } catch (error) {
        console.log(error);
    }
}

export default deleteUser;
